<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();
const calendarFiltersStore = useCalendarFiltersStore();
const { openConfirmAlert } = useUserMessages();

async function toggleSaveFilter(value: boolean) {
  await settingsStore.set('calendarFilterSave', value);

  calendarFiltersStore.saveFilter();

  if (value === false && calendarFiltersStore.usedFiltersCount > 0) {
    presentResetFilterAlert();
  }
}

async function presentResetFilterAlert() {
  const confirmed = await openConfirmAlert(t('settings.calendar.resetFilterHeader'), t('settings.calendar.resetFilterMessage'), t('buttons.yes'), t('buttons.no'));

  if (confirmed) {
    calendarFiltersStore.resetFilter();
  }
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.calendarFilterSave"
    :label="t('settings.calendar.saveFilter')"
    :description="t('settings.calendar.saveFilterDescription')"
    @change="toggleSaveFilter"
  />
</template>
